import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'pnnl-react-core';
import { Row, Col } from 'react-bootstrap';
import { CVGPlot, LHSPlot, LCSPlot } from 'components/plots';

export const Intermediate = ({ tm30, downloading }) => {
  const reportColumnWidths = {
    xs: downloading ? 6 : 12,
    sm: downloading ? 6 : 12,
    md: downloading ? 6 : 12,
    lg: 6,
  };
  const location = window.location;

  return (
    <div id='intermediate'>
      <Row align='center'>
        <Col {...reportColumnWidths}>
          <CVGPlot numericalResults={tm30} active='intermediate'></CVGPlot>
        </Col>
        <Col {...reportColumnWidths} style={{ marginTop: '3.8rem' }}>
          <LCSPlot data={tm30.local_chroma_shift} active='Intermediate' />
          <div style={{ margin: '1.85rem 0' }}></div>
          <LHSPlot data={tm30.local_hue_shift} active='Intermediate' />
        </Col>
      </Row>
      {window.location != window.parent.location && (
        <div
          style={{
            display: 'flex',
            textAlign: 'left',
            marginTop: '3rem',
            fontWeight: '500',
          }}
        >
          <img
            alt='app-logo'
            style={{ width: 40, height: 40, marginLeft: 10 }}
            src={`${process.env.PUBLIC_URL}/images/ies-logo.jpg`}
          />
          <p style={{ marginLeft: 15 }}>
            The content of this report was generated by the Illuminating
            Engineering Society’s online spectral calculator (
            <a
              target='_blank'
              rel='noopener noreferrer'
              href='https://www.ies.org/spectral-calculator'
            >
              www.ies.org/spectralcalculator
            </a>
            ), in conformance with the ANSI/IES {downloading && <br />} TM-30-20
            standard published by the IES, 120 Wall Street, New York, New York
            10005.
          </p>
        </div>
      )}
    </div>
  );
};

Intermediate.propTypes = {
  tm30: PropTypes.object,
};
